"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "acqui-terme": {
    "e4adf7eb": [{
      "hkey": "b5080cf4",
      "slug": "acqui-terme",
      "name": "Acqui Terme",
      "primary": true,
      "skipSearch": false
    }],
    "cascinone": [{
      "hkey": "b5080cf4",
      "slug": "acqui-terme",
      "name": "Acqui Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0073e43f": [{
      "hkey": "b5080cf4",
      "slug": "acqui-terme",
      "name": "Acqui Terme",
      "primary": true,
      "skipSearch": false
    }],
    "froncino": [{
      "hkey": "b5080cf4",
      "slug": "acqui-terme",
      "name": "Acqui Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8b699989": [{
      "hkey": "b5080cf4",
      "slug": "acqui-terme",
      "name": "Acqui Terme",
      "primary": true,
      "skipSearch": false
    }],
    "ivaldi": [{
      "hkey": "b5080cf4",
      "slug": "acqui-terme",
      "name": "Acqui Terme",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;